import BitrixRequests from './bitrixRequests'

export default class BitrixApi {
  public requests: BitrixRequests

  constructor(ctx: any) {
    this.requests = new BitrixRequests(ctx)
  }
}
